import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

// Initialize Firebase Functions
const createSignatureRequestFn = httpsCallable(functions, 'createSignatureRequest');
const checkSignatureStatusFn = httpsCallable(functions, 'checkSignatureStatus');
const getSignedDocumentFn = httpsCallable(functions, 'getSignedDocument');
const completeInPortalSignatureFn = httpsCallable(functions, 'completeInPortalSignature');

/**
 * Create a signature request for an estimate
 * @param {string} estimateId - The estimate ID
 * @param {string} pdfUrl - URL to the PDF document
 * @param {string} clientEmail - Client's email
 * @param {string} clientName - Client's name
 * @param {Object} estimateData - Estimate data
 * @returns {Promise} - Signature request response
 */
export const createSignatureRequest = async (estimateId, pdfUrl, clientEmail, clientName, estimateData) => {
  try {
    console.log('Creating signature request:', { estimateId, pdfUrl, clientEmail, clientName });
    
    const result = await createSignatureRequestFn({
      estimateId,
      pdfUrl,
      clientEmail,
      clientName,
      estimateData
    });
    
    return result.data;
  } catch (error) {
    console.error('Error creating signature request:', error);
    throw error;
  }
};

/**
 * Check signature request status
 * @param {string} signatureRequestId - The signature request ID
 * @param {string} estimateId - The estimate ID
 * @returns {Promise} - Signature status response
 */
export const checkSignatureStatus = async (signatureRequestId, estimateId) => {
  try {
    console.log('Checking signature status:', { signatureRequestId, estimateId });
    
    const result = await checkSignatureStatusFn({
      signatureRequestId,
      estimateId
    });
    
    return result.data;
  } catch (error) {
    console.error('Error checking signature status:', error);
    throw error;
  }
};

/**
 * Get signed document URL
 * @param {string} signatureRequestId - The signature request ID
 * @returns {Promise} - Signed document response
 */
export const getSignedDocument = async (signatureRequestId) => {
  try {
    console.log('Getting signed document:', signatureRequestId);
    
    const result = await getSignedDocumentFn({
      signatureRequestId
    });
    
    return result.data;
  } catch (error) {
    console.error('Error getting signed document:', error);
    throw error;
  }
};

/**
 * Complete in-portal signature
 * @param {string} estimateId - The estimate ID
 * @param {string} signatureRequestId - The signature request ID
 * @param {string} signatureData - Base64 signature data
 * @param {string} clientName - Client's name
 * @param {string} clientEmail - Client's email
 * @returns {Promise} - Signature completion response
 */
export const completeInPortalSignature = async (estimateId, signatureRequestId, signatureData, clientName, clientEmail) => {
  try {
    console.log('Completing in-portal signature:', { estimateId, signatureRequestId, clientName });
    
    const result = await completeInPortalSignatureFn({
      estimateId,
      signatureRequestId,
      signatureData,
      clientName,
      clientEmail
    });
    
    return result.data;
  } catch (error) {
    console.error('Error completing in-portal signature:', error);
    throw error;
  }
};
